var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { useComponentProps } from '../context/component-props-context';
import { useSpringValues } from '../hooks/use-spring-values';
import { animated, to } from '@react-spring/web';
var cls = classNames('segment-bar');
export var SegmentBarDefaultProps = {
  height: 10,
  maxValue: 5,
  springConfig: {
    duration: 800
  },
  animate: true,
  from: {
    value: 0
  },
  tick: {
    width: 2,
    colors: {
      background: 'app-chrome'
    }
  },
  colors: {
    fill: 'strong-chrome',
    background: 'canvas'
  }
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    position: relative;\n    ", ";\n    \n    ", "\n  "], ["\n    position: relative;\n    ", ";\n    \n    ", "\n  "])), theme.APPLY_COLORS, function (_a) {
    var _height = _a._height;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      height: ", "px;\n    "], ["\n      height: ", "px;\n    "])), _height);
  })
});
var TickStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    position: absolute;\n    top: 0;\n    font-size: 0;\n    z-index: 2;\n    ", ";\n    \n    ", "\n  "], ["\n    position: absolute;\n    top: 0;\n    font-size: 0;\n    z-index: 2;\n    ", ";\n    \n    ", "\n  "])), theme.APPLY_COLORS, function (_a) {
    var _height = _a._height,
      _left = _a._left,
      _width = _a._width;
    return css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      height: ", "px;\n      width: ", "px;\n      left: calc(", "% - ", "px);\n    "], ["\n      height: ", "px;\n      width: ", "px;\n      left: calc(", "% - ", "px);\n    "])), _height, _width, _left, _width / 2);
  })
});
var BarStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    z-index: 1;\n    top: 0;\n    left: 0;\n    height: 100%;\n    position: absolute;\n    transition: width 1s ease-out;\n    ", ";\n\n  "], ["\n    z-index: 1;\n    top: 0;\n    left: 0;\n    height: 100%;\n    position: absolute;\n    transition: width 1s ease-out;\n    ", ";\n\n  "])), theme.APPLY_COLORS)
});
// -------- Components -------->
var My = {
  NAME: 'SegmentBar',
  Container: styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Tick: styled.span(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), TickStyles),
  Bar: styled(animated.span)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), BarStyles)
};
export var SegmentBar = function (props) {
  var _a;
  var componentProps = useComponentProps(My.NAME, SegmentBarDefaultProps, props);
  var className = componentProps.className,
    color = componentProps.color,
    colors = componentProps.colors,
    height = componentProps.height,
    backgroundColor = componentProps.backgroundColor,
    tick = componentProps.tick,
    tickColor = componentProps.tickColor,
    tickWidth = componentProps.tickWidth,
    maxValue = componentProps.maxValue;
  var tickCount = maxValue;
  var values = useSpringValues(componentProps);
  var barColors = {
    background: color || colors.fill
  };
  var containerColors = {
    background: backgroundColor || colors.background
  };
  var tickColors = {
    background: tickColor || ((_a = tick === null || tick === void 0 ? void 0 : tick.colors) === null || _a === void 0 ? void 0 : _a.background)
  };
  var barWidth = function (v) {
    return v === 0 ? '0%' : "".concat(v / maxValue * 100, "%");
  };
  return React.createElement(My.Container, {
    colors: containerColors,
    _height: height,
    className: cls.name(className)
  }, tickCount >= 1 && __spreadArray([], __read(Array(tickCount).keys()), false).map(function (i) {
    return React.createElement(My.Tick, {
      key: i,
      _height: height,
      colors: tickColors,
      _width: tickWidth || (tick === null || tick === void 0 ? void 0 : tick.width),
      _left: Math.floor(i / tickCount * 100)
    });
  }), React.createElement(My.Bar, {
    colors: barColors,
    style: {
      width: to([values.value], barWidth)
    }
  }));
};
SegmentBar.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;